export class WayPoints {

    locationName: string;
    longitude: number;
    latitude: number;
}

export class MapOtpimizationModel {

    startLocationName: string;
    startLongitude: number;
    startLatitude: number;
    finishLocationName: string;
    finishLongitude: number;
    finishLatitude: number;
    requiredTrafficAndWeatherData: boolean;
    circularDirection: boolean;
    wayPoints: WayPoints[] = [];
    companyCode: number;
}
